let menuIcon = document.querySelector('.menu-icon');
if (menuIcon){
  menuIcon.addEventListener("click", function(){
    let navLinkContainer = document.querySelector('.mobile-nav-link-container');
    navLinkContainer.classList.toggle('show-mobile-nav');
  });
}
